import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar el bucle",
    opening: localizedGenderNode(
      [
      "Hoy no paro de pensar.",
      "Solo noto: es un bucle."
    ],
      [
      "Hoy no paro de pensar.",
      "Solo noto: es un bucle."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "En que me quedo atascado/a una y otra vez?",
      "Cual es el primer pensamiento que salta?",
      "Que siento en mi cuerpo?"
    ],
      [
      "En que me quedo atascado/a una y otra vez?",
      "Cual es el primer pensamiento que salta?",
      "Que siento en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un bucle es una experiencia, no soy yo."
    ],
      [
      "Un bucle es una experiencia, no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + \"Esto es un bucle\".",
      "una respiracion + \"Esto es un bucle\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer momento",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que empieza.",
      "Solo noto."
    ],
      [
      "Hoy noto el momento en que empieza.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ],
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pasa justo antes de que empiece el bucle?",
      "Donde me encuentra en el día?",
      "Que intento evitar?"
    ],
      [
      "Que pasa justo antes de que empiece el bucle?",
      "Donde me encuentra en el día?",
      "Que intento evitar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "En el primer momento tengo un poco de espacio."
    ],
      [
      "En el primer momento tengo un poco de espacio."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion cuando empieza.",
      "una respiracion cuando empieza."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Señales del cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi cuerpo antes del pensamiento.",
      "Me quedo conmigo."
    ],
      [
      "Hoy escucho mi cuerpo antes del pensamiento.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ],
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Donde siente mi cuerpo el bucle?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ],
      [
      "Donde siente mi cuerpo el bucle?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo intenta cuidarme."
    ],
      [
      "Mi cuerpo intenta cuidarme."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho y una respiracion.",
      "una mano en el pecho y una respiracion."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Historia vs. hecho",
    opening: localizedGenderNode(
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia."
    ],
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cual es el hecho simple aquí?",
      "Que historia salto?",
      "Que posibilidad más suave tambien podria ser cierta?"
    ],
      [
      "Cual es el hecho simple aquí?",
      "Que historia salto?",
      "Que posibilidad más suave tambien podria ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no soy yo."
    ],
      [
      "Una historia no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es una historia que aparece\".",
      "una frase interna - \"Esto es una historia que aparece\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Lo que activa",
    opening: localizedGenderNode(
      [
      "Hoy identifico lo que enciende la preocupacion.",
      "No para evitarlo."
    ],
      [
      "Hoy identifico lo que enciende la preocupacion.",
      "No para evitarlo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mis pies.",
      "Una respiracion."
    ],
      [
      "Siento mis pies.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que suele activar la preocupacion?",
      "Que pequeña señal noto?",
      "Que necesito en ese momento?"
    ],
      [
      "Que suele activar la preocupacion?",
      "Que pequeña señal noto?",
      "Que necesito en ese momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Nombrar un disparador es el inicio de una eleccion."
    ],
      [
      "Nombrar un disparador es el inicio de una eleccion."
    ]
    ),
    action: localizedGenderNode(
      "nombrar un disparador.",
      "nombrar un disparador."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Voces internas",
    opening: localizedGenderNode(
      [
      "Hoy noto la voz que amplifica la preocupacion.",
      "No discuto con ella."
    ],
      [
      "Hoy noto la voz que amplifica la preocupacion.",
      "No discuto con ella."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Ablando un poco los hombros.",
      "Una respiracion."
    ],
      [
      "Ablando un poco los hombros.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que frase de preocupacion se repite en mi?",
      "Que intenta hacer esa frase?",
      "Que dice mi voz tranquila?"
    ],
      [
      "Que frase de preocupacion se repite en mi?",
      "Que intenta hacer esa frase?",
      "Que dice mi voz tranquila?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo elegir que voz sostener."
    ],
      [
      "Puedo elegir que voz sostener."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna suave.",
      "una frase interna suave."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Necesidad de seguridad",
    opening: localizedGenderNode(
      [
      "Hoy toco la necesidad debajo de la preocupacion.",
      "No resuelvo."
    ],
      [
      "Hoy toco la necesidad debajo de la preocupacion.",
      "No resuelvo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pongo una mano en el pecho.",
      "Una respiracion."
    ],
      [
      "Pongo una mano en el pecho.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que necesito para sentirme más seguro/a?",
      "Que en mi pide calor o cercanía?",
      "Como se siente cuando me doy un momento?"
    ],
      [
      "Que necesito para sentirme más seguro/a?",
      "Que en mi pide calor o cercanía?",
      "Como se siente cuando me doy un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Detras de la preocupacion hay una peticion."
    ],
      [
      "Detras de la preocupacion hay una peticion."
    ]
    ),
    action: localizedGenderNode(
      "escribir una peticion para mi.",
      "escribir una peticion para mi."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Una pequeña conexion",
    opening: localizedGenderNode(
      [
      "Hoy busco una pequeña conexion dentro de mi.",
      "No grande, solo posible."
    ],
      [
      "Hoy busco una pequeña conexion dentro de mi.",
      "No grande, solo posible."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento la espalda apoyada.",
      "Una respiracion."
    ],
      [
      "Siento la espalda apoyada.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que me da sensación de conexion ahora?",
      "Que palabra me calma?",
      "Que puedo darme por un momento?"
    ],
      [
      "Que me da sensación de conexion ahora?",
      "Que palabra me calma?",
      "Que puedo darme por un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pequeña conexion sigue siendo conexion."
    ],
      [
      "Una pequeña conexion sigue siendo conexion."
    ]
    ),
    action: localizedGenderNode(
      "una palabra tranquila en mi corazon.",
      "una palabra tranquila en mi corazon."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Compasion hacia mi",
    opening: localizedGenderNode(
      [
      "Hoy me hablo con suavidad.",
      "No como un juez."
    ],
      [
      "Hoy me hablo con suavidad.",
      "No como un juez."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Suavizo la mandíbula.",
      "Una respiracion."
    ],
      [
      "Suavizo la mandíbula.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como le hablaria a un amigo aquí?",
      "Que frase suave necesito escuchar?",
      "Que puedo perdonarme?"
    ],
      [
      "Como le hablaria a un amigo aquí?",
      "Que frase suave necesito escuchar?",
      "Que puedo perdonarme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La suavidad no cancela la preocupacion."
    ],
      [
      "La suavidad no cancela la preocupacion."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mi.",
      "una frase suave para mi."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una peticion interna",
    opening: localizedGenderNode(
      [
      "Hoy me doy una peticion clara.",
      "No una exigencia, solo una peticion."
    ],
      [
      "Hoy me doy una peticion clara.",
      "No una exigencia, solo una peticion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el abdomen aflojar un poco.",
      "Una respiracion."
    ],
      [
      "Siento el abdomen aflojar un poco.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cual es mi peticion más importante ahora?",
      "Como decirla en una sola frase?",
      "Que estoy dispuesto/a a darme a cambio?"
    ],
      [
      "Cual es mi peticion más importante ahora?",
      "Como decirla en una sola frase?",
      "Que estoy dispuesto/a a darme a cambio?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una peticion puede calmarme."
    ],
      [
      "Una peticion puede calmarme."
    ]
    ),
    action: localizedGenderNode(
      "escribir la peticion en una frase corta.",
      "escribir la peticion en una frase corta."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Valor sobre preocupacion",
    opening: localizedGenderNode(
      [
      "Hoy me recuerdo lo que me importa.",
      "No para cancelar la preocupacion."
    ],
      [
      "Hoy me recuerdo lo que me importa.",
      "No para cancelar la preocupacion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto el rostro más calmado.",
      "Una respiracion."
    ],
      [
      "Noto el rostro más calmado.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que valor me importa frente a esta preocupacion?",
      "Como se ve ese valor en un día normal?",
      "Que pequeño paso interno lo honra?"
    ],
      [
      "Que valor me importa frente a esta preocupacion?",
      "Como se ve ese valor en un día normal?",
      "Que pequeño paso interno lo honra?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un valor me da direccion."
    ],
      [
      "Un valor me da direccion."
    ]
    ),
    action: localizedGenderNode(
      "elegir un valor y repetirlo en mi corazon.",
      "elegir un valor y repetirlo en mi corazon."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Como estoy conmigo",
    opening: localizedGenderNode(
      [
      "Hoy observo como me trato.",
      "No juzgo."
    ],
      [
      "Hoy observo como me trato.",
      "No juzgo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me doy medio minuto de silencio.",
      "Una respiracion."
    ],
      [
      "Me doy medio minuto de silencio.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando me presiono a mi mismo/a?",
      "Donde puedo aflojar un poco?",
      "Como quiero hablarme en el futuro?"
    ],
      [
      "Cuando me presiono a mi mismo/a?",
      "Donde puedo aflojar un poco?",
      "Como quiero hablarme en el futuro?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Como estoy conmigo importa."
    ],
      [
      "Como estoy conmigo importa."
    ]
    ),
    action: localizedGenderNode(
      "una frase de respeto hacia mi.",
      "una frase de respeto hacia mi."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un pequeño cambio",
    opening: localizedGenderNode(
      [
      "Hoy elijo un pequeño cambio que puedo sostener.",
      "No una revolucion."
    ],
      [
      "Hoy elijo un pequeño cambio que puedo sostener.",
      "No una revolucion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el cuerpo estable por un momento.",
      "Una respiracion."
    ],
      [
      "Siento el cuerpo estable por un momento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pequeño cambio podria ayudarme hoy?",
      "Como se veria en la practica?",
      "Que estoy dispuesto/a a intentar una vez?"
    ],
      [
      "Que pequeño cambio podria ayudarme hoy?",
      "Como se veria en la practica?",
      "Que estoy dispuesto/a a intentar una vez?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Lo pequeño suficiente es suficiente."
    ],
      [
      "Lo pequeño suficiente es suficiente."
    ]
    ),
    action: localizedGenderNode(
      "un paso pequeño para mi.",
      "un paso pequeño para mi."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy cierro con suavidad.",
      "Elijo una frase que me devuelve."
    ],
      [
      "Hoy cierro con suavidad.",
      "Elijo una frase que me devuelve."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el aire entrar y salir.",
      "Una respiracion."
    ],
      [
      "Siento el aire entrar y salir.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que aprendi sobre este bucle?",
      "Cual es la señal más temprana de que sube?",
      "Que frase me devuelve al momento anterior?"
    ],
      [
      "Que aprendi sobre este bucle?",
      "Cual es la señal más temprana de que sube?",
      "Que frase me devuelve al momento anterior?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Elijo presencia antes de reaccionar."
    ],
      [
      "Elijo presencia antes de reaccionar."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion y mi frase de regreso.",
      "una respiracion y mi frase de regreso."
    ),
  },
].map(buildNormalizedDay);

export const overthinkingChronicWorryBlueprintEs = buildNormalizedPilotBlueprint({
  id: "overthinking_chronic_worry_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "overthinking_chronic_worry",
  category: "anxiety",
  journeyName: {
    he: "אובר-ת׳ינקינג ודאגנות כרונית",
    en: "Overthinking and chronic worry",
    es: "Sobrepensar y preocupacion cronica",
  },
  days,
});

export default overthinkingChronicWorryBlueprintEs;
